<template>
  <div>
    <nav-breadcrumb :menu="[{label: '缴退保证金'}]"/>
    <el-tabs v-model="applicationStatus">
      <el-tab-pane label="待复核" name="Pending Approval" />
      <!-- <el-tab-pane label="审核通过" name="Approved" />-->
      <el-tab-pane label="已复核" name="Approved,Rejected" />
    </el-tabs>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="listData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "DepositApplicationForApprovalList",
      data(){
        return {
          page: 1,
          pageSize: 20,
          listData: {},
          dealerOptions:[],
          applicationStatus:'Pending Approval',
          filters: {
            labelWidth: '150px',
            form: {
              d__dealerId:'',
              t__applicationDate:[],
              t__applicationTypeCode:[],
            },
            columns: [
              {
                label: '渠道商',
                component: 'el-select',
                field: 'd__dealerId',

                options:this.dealerOptions,
              },
              {
                label: '类型',
                component: 'el-select',
                field: 't__applicationTypeCode',

                options:[
                  {
                    label:'缴纳',
                    value:'DA'
                  },
                  {
                    label:'退还',
                    value:'DR'
                  }
                ],
              },
              {
                label: '日期',
                component: 'date-range-picker',
                field: 't__applicationDate',
                op: ['gteq', 'lteq'],
              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          },
          actions: [
            {
              label: '缴纳',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'addDA'
                })
              }
            },
            {
              label: '退还',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'addDR'
                })
              }
            }
          ],
        }
      },
      computed:{
        columns: function(){
          return [
            {
              type: 'index'
            },
            {
              label: '类型',
              field: 't__applicationTypeCode',
              formatter: function (r,c,v) {
                return Status2CN(v)
              }
            },

            {
              label: '渠道商',
              field: 'd__dealerName'
            },
            {
              label: '日期',
              field: 't__applicationDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },

            {
              label: '金额',
              field: 't__txAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '流水号',
              field: 't__reference'
            },
            {
              label: '备注',
              field: 't__remarks'
            },
            {
              label: '状态',
              field: 't__applicationStatus',
              formatter: function (r,c,v) {
                return Status2CN('Deposit__'+v)
              }
            },
            {
              label: '操作',
              opts:[
                {
                  label: '查看',
                  class: 'el-icon-view',
                  clickHandler: (index, row) => {
                    this.$router.push({
                      name: 'ApproveDepositApplication',
                      query: {
                        'applicationId': row.t__applicationId,
                        'status':'view'
                      }
                    })

                  },
                },

                {
                  label: '复核',
                  class: 'el-icon-success',
                  clickHandler: (index, row) => {
                    this.$router.push({
                      name: 'ApproveDepositApplication',
                      query: {
                        'applicationId': row.t__applicationId,
                        'status':'edit'

                      }
                    })

                  },
                  conditions: row=> {
                    return row.t__hasRole2 == 'true'&&row.t__applicationStatus=='Pending Approval'

                  }
                },

              ]
            }
          ]
        },
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              'xlist.search.t.applicationStatus' : this.applicationStatus,
              'xlist.search.t.applicationStatus.op' : 'in',
              'xlist.sort.dataField': 't.applicationDate',
              'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        },
      },
      mounted(){
        this.getData()
        this.getDealerList()
      },
      methods:{
        getData: function () {
          xhr.getDepositApplicationForApprovalList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.listData = res.data
              } catch (e) {

              }
            })
        },
        getDealerList: function () {
          xhr.getDealerList(
            Object.assign({pageSize:0}, {}, {}),
            res=> {
              try {
                this.filters.columns[0].options = res.data.data.map(item=>{
                  return {
                    label: item.d__dealerName,
                    value:item.d__dealerId,
                  }
                })
              }catch(e){

              }
            })

        },
        /*exportPdf: function (index, row) {
          try {
            window.open('/ix/fang/financing/LoanApproved.jasper?applicationId='+row.pay__applicationId)
          }
          catch (e) {

          }
        },*/
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/DepositApplicationForApprovalList.vue